export default "__VITE_ASSET__8e344f47__"